
interface perksProps {
    icon:string;
    title:string;
    desc:string;
}
export interface whyWorkWithProps {
    content : {
        titleN:string;
        titleI:string;
        subText:string;
        picture:string;
        perks: perksProps[];
    }
}
const WhyWorkWith = ({content}:whyWorkWithProps) => {
  return (
    // updated section
    <div className='px-4 lg:px-0'>
        <div style={{
            backgroundImage:"url(/img/whybg.png)", 
            backgroundPosition:'center',
            backgroundSize:'cover',
            backgroundRepeat:'no-repeat'
            }}
            className="lg:p-10 pb-6 rounded-xl lg:rounded-none"
            >
                <img className="lg:hidden" src={content.picture} alt="" />
            <div className="flex justify-center flex-col items-center p-6">
                <h1 className='lg:text-center text-[#fff] font-Rob font-[600] text-[28px] leading-[28px] md:text-[44px] md:leading-[45px]'>{content.titleN} <span className='text-[#fff] text-[32px] md:text-[50px] lg:text-[55px] font-[800] font-playfair italic'>{content.titleI}</span></h1>
                <p className='lg:text-center font-int font-[300] text-[16px] text-[#fff] my-4 lg:w-[50%] md:mb-8'>{content.subText}</p>
            </div>
            <div className="flex justify-between gap-6 flex-col-reverse lg:flex-row">
                <div className="lg:w-1/2">
                    {
                        content.perks.map((i, index)=>(
                            <div key={index} className="md:w-[70%] flex gap-2">
                                <img src={i.icon} className="w-[4rem] h-[4rem] md:w-[7rem] md:h-[7rem]" alt="" />
                                <div className='pt-4'>
                                    <p className="text-white text-[16px] font-[600]">{i.title}</p>
                                    <p className="text-white text-[12px] ">{i.desc}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <img className="hidden lg:block lg:w-1/2" src={content.picture} alt="" />
            </div>
        </div>        
    </div>

  )
}

export default WhyWorkWith







